import { Route, Routes } from "react-router-dom";
import SupplierStocksPage from "./SupplierStocksPage";
import SuppliersPage from "./SuppliersPage";

const ChinaV2Routes = () => {
  return (
    <Routes>
      <Route index element={<SuppliersPage />} />
      <Route path=":id" element={<SupplierStocksPage />} />
    </Routes>
  );
};

export default ChinaV2Routes;
